import React from "react";
import HumanBanner from "../humanresources/HumanBanner";
import SmallBusinessPlace from "../smallbusiness/SmallBusinessPlace";
import SmallBusinessBuilt from "../smallbusiness/SmallBusinessBuilt";
import SmallBusinessGallery from "../smallbusiness/SmallBusinessGallery";
import SmallMidSized from "../smallbusiness/SmallMidSized";
import SmallWorkforce from "../smallbusiness/SmallWorkforce";
import SmallLaunch from "../smallbusiness/SmallLaunch";
import SmallBoost from "../smallbusiness/SmallBoost";
import HumanCompany from "../humanresources/HumanCompany";

const bannerData = {
  head: "Enterprise-Grade Document Management & Workflow Automation",
  desc: "Managing information at scale shouldn’t slow your business down. Dox and Box empowers large enterprises with secure, intelligent Enterprise-Grade DMS (Document Management System) and automated workflows, ensuring seamless information flow, enhanced productivity, and complete control across departments and locations.",
  slug: "",
  btn: "Contact Us",
  img: "/assets/images/enterprises-banner-image.webp"
}

const placeData = {
  head: "A Secure Foundation for Enterprise Information",
  desc: "From document creation and approvals to sharing, storage, secure disposal, enterprise operations demand structured and reliable systems. Dox and Box delivers end-to-end document lifecycle management that enhances visibility, reduces manual effort, ensures instant access to critical information, driving efficiency across the organization."
}

const galleryData = [
  {
    head: "Capture, Protect, Control Documents",
    list: [
      "Easily capture documents from multiple sources including scanners, emails, digital uploads. Automatically extract and organize key data while ensuring every document is protected with advanced encryption and role-based access controls, keeping your enterprise data secure at all times.",
    ],
    img: "/assets/images/enterprises-gallery-image-1.webp",
    label: "Organize, access and secure critical enterprise documents"
  },
  {
    head: "Automate Workflows with Precision",
    list: [
      "Design workflows that align with your business processes and eliminate inefficiencies. Assign tasks, track progress in real time, enable automated notifications, ensuring faster approvals, improved accountability, streamlined operations."
    ],
    img: "/assets/images/enterprises-gallery-image-2.webp",
    label: "Automate business processes (left) and assign users document tasks (right)"
  },
  {
    head: "Enable Seamless Collaboration Across Teams",
    list: [
      "Connect distributed teams through a centralized document repository. Access, share, collaborate on files in real time with version control and secure access, empowering teams to work efficiently from anywhere."
    ],
    img: "/assets/images/enterprises-gallery-image-3.webp",
    label: "Expedite business processes and document tasks with access on any device"
  },
]

const builtData = {
  head: "A Modern Platform Built for Enterprise Scale",
  desc: "With a focus on scalability, security, seamless integration, Dox and Box enables businesses to manage information efficiently, while maintaining a user-friendly experience that drives adoption across teams.",
  boxes: [
    {
      img: "/assets/images/enterprises-modern-icon-1.webp",
      title: "Cloud-Enabled Access",
      desc: "Access documents securely from any device, anytime, through a browser-based platform.",
    },
    {
      img: "/assets/images/enterprises-modern-icon-2.webp",
      title: "Flexible Deployment",
      desc: "Choose from cloud, on-premises, or hybrid environments based on your enterprise needs.",
    },
    {
      img: "/assets/images/enterprises-modern-icon-3.webp",
      title: "Advanced Security",
      desc: "Protect sensitive data with encryption, access controls, multi-layered backup systems.",
    },
    {
      img: "/assets/images/enterprises-modern-icon-4.webp",
      title: "Seamless Integration",
      desc: "Integrate effortlessly and efficiently with your existing enterprise tools and IT ecosystem.",
    },
  ]
}

const midData = {
  head: "Designed for High-Performance Enterprise Environments",
  desc: "From multi-location operations to high-volume document workflows, Dox and Box supports organizations of all sizes, especially enterprises managing large-scale, document-intensive processes where speed, reliability, security are critical.",

}

const workforceData = {
  head: "How to take control of repetitive or complex manual processes with simple workflow automation",
  desc: "Employees stuck in repetitive and/or complex time-consuming processes with scattered information work hard but can’t deliver the effectiveness that they know they’re capable of. Move away from slow, manual information processes with a modern workflow automation solution.",
  img: "/assets/images/enterprises-control-img.webp",
  btn: "Watch the webinar",
  slug: "",
}

const launchData = {
  head: "Accelerate Digital Transformation with Ready-to-Deploy Solutions",
  desc: "To help enterprises fast-track their digital journey, Dox and Box offers pre-configured document management and workflow solutions that enable rapid deployment and faster ROI. These solutions are designed to standardize processes, reduce implementation time, deliver immediate operational value.",
  boxes: [
    {
      img: "/assets/images/enterprises-solutions-img-1.webp",
      title: "Cloud Document Storage",
      desc: "Store, manage, retrieve enterprise documents within a secure cloud environment. With advanced indexing, controlled access, real-time updates, your teams can collaborate seamlessly while ensuring data protection and compliance.",
      label: "SECURE, SCALABLE & ALWAYS ACCESSIBLE",
      btnText: "Know More",
      slug: ""
    },
    {
      img: "/assets/images/enterprises-solutions-img-2.webp",
      title: "Automated Workflow Management",
      desc: "Automate complex business workflows with rule-based approvals, notifications, real-time tracking. Reduce manual effort, improve accuracy, enable faster, more consistent decision-making across departments.",
      label: "STREAMLINE PROCESSES WITH INTELLIGENT AUTOMATION",
      btnText: "Know More",
      slug: ""
    },
  ]
}

const boostData = {
  heading: "Optimize Financial Operations with Workflow Automation",
  description: "Accounts payable and other finance processes are often burdened by manual, repetitive tasks. Dox and Box helps enterprises automate key workflows—such as invoice processing and approvals—improving efficiency, reducing errors, boosting team productivity.",
  btn: "Read More",
  slug: "",
}

export default function Enterprises({ initialData }) {
  return (
    <>
      <HumanBanner data={bannerData} />
      <SmallBusinessPlace data={placeData} />
      <SmallBusinessGallery data={galleryData} />
      <SmallBusinessBuilt data={builtData} />
      <SmallMidSized data={midData} initialData={initialData}/>
      <SmallWorkforce data={workforceData} />
      <SmallLaunch data={launchData} />
      <SmallBoost data={boostData} />
      <HumanCompany />
    </>
  )
}